import { Box, Typography } from "@mui/material";
import React from "react";
import GeneralNews from "./GeneralNews";

function Rightbar({ news }) {
  return (
    <>
      {/* תגיות META לקידום אורגני */}
      <meta
        name="description"
        content="בידאיט - הפלטפורמה שמחברת אותך עם בעלי המקצוע הטובים ביותר. מצא בעלי מקצוע מומלצים במהירות ובקלות!"
      />
      <meta
        name="keywords"
        content="בעלי מקצוע מומלצים, חיפוש בעלי מקצוע, טכנאים, שיפוצניקים, חשמלאים, אינסטלטורים, שירותים לבית"
      />
      <meta name="robots" content="index, follow" />

      <Box
        flex={1}
        sx={{
          width: { xs: "100%", lg: "330px" },
          maxWidth: { xs: "100%", lg: "360px" },
          flexShrink: 0,
          position: { lg: "sticky" },
          top: { lg: 88 },
          p: { xs: 1, sm: 1.5 },
          borderRadius: "24px",
          backgroundColor: "rgba(255,255,255,.92)",
          border: "1px solid #E2EBF3",
          boxShadow: "0 16px 38px rgba(24, 67, 105, .09)",
          backdropFilter: "blur(12px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            mb: 1.25,
            px: 1,
            py: 0.75,
          }}
        >
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: "13px",
              display: "grid",
              placeItems: "center",
              color: "#FFFFFF",
              fontSize: "21px",
              background: "linear-gradient(145deg, #FFB84D, #F49A1B)",
              boxShadow: "0 8px 18px rgba(244, 154, 27, .25)",
            }}
          >
            !
          </Box>
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                color: "#173B57",
                fontWeight: 800,
                fontSize: { xs: "1.18rem", sm: "1.3rem" },
                lineHeight: 1.2,
              }}
            >
              הודעות חשובות
            </Typography>
            <Typography
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                color: "#72869A",
                fontSize: "0.82rem",
                mt: 0.25,
              }}
            >
              עדכונים שכדאי להכיר
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {Array.from(news).map((news) => {
            return <GeneralNews key={news.id} news={news} />;
          })}
        </Box>
      </Box>
    </>
  );
}

export default Rightbar;
